const styles = {
  socialProofItem: {
    display: 'inline-block',
    padding: 1,
    width: 120,
    height: 80
  },

  socialProofImage: {
    height: 80,
    width: 'auto',
    objectFit: 'contain',
    borderRadius: 1,
    filter: 'grayscale(100%)',
    opacity: 0.7,
    transition: 'filter 0.3s ease, opacity 0.3s ease',
    '&:hover': {
      filter: 'grayscale(0%)',
      opacity: 1
    }
  }
}

export default styles
